import type {RefObject} from 'react';
import {useHotkeys} from 'react-hotkeys-hook';

type Props = {
    keys: string;
    callback: () => void;
    children: (ref: RefObject<HTMLElement>) => JSX.Element;
};

export const HotkeyListener = ({keys, children, callback}: Props) => {
    const ref = useHotkeys(keys, callback);

    return children(ref);
};
